// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Articles_subtitle__1MxsA","title":"Articles_title__wBGNh","articlesSwiper":"Articles_articlesSwiper__25-ke"};